import { forwardRef } from 'react'

import { EmptyFile } from '.'
import { EmptyFileInputProps } from './interface'
import * as Styled from './styles'

const EmptyFileInput = forwardRef<HTMLInputElement, EmptyFileInputProps>(
  ({ isDragAccept, id, name, getInputProps }, ref) => (
    <EmptyFile dragAccept={isDragAccept}>
      <Styled.FileUploadInput
        {...getInputProps()}
        id={id}
        name={name}
        ref={ref}
      />
    </EmptyFile>
  )
)

EmptyFileInput.displayName = 'EmptyFileInput'

export { EmptyFileInput }
